import api from './client';

export const recommendationsApi = {
  getPersonalized: (body) => api.post('/recommendations', body),
};
